const GetCardCodes = async (props) => { 
    const _res = await props._api({
        ...props,
        method: "get",
        endpoint: "/api/LookUpValue/v2/Customers/" + props.query,
        param: "",
    });

    return _res;
}

export default GetCardCodes;